import { FronteggContext } from '@frontegg/rest-api';
import { Axios } from 'src/lib';
import {
  listKnowledgebaseOverridesConfig,
  getKnowledgebaseOverridesConfig,
  createKnowledgebaseOverridesConfig,
  updateKnowledgebaseOverridesConfig,
} from '../lib/knowledgebaseoverrides.url';
import { showToastError } from 'src/utilities/errortoast';
import { showToastSuccess } from 'src/utilities/toast';
import {
  knowledgebaseOverridesListSlice,
  knowledgebaseOverridesItemSlice,
  knowledgebaseOverridesLoadingSlice,
} from '../slices/knowledgebase.slice';

export const listKnowledgebaseOverridesAction = (org_uuid, filters = {}) => {
  return async (dispatch) => {
    dispatch(knowledgebaseOverridesLoadingSlice(true));
    try {
      const token = FronteggContext.getAccessToken();
      const headers = {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        Authorization: `Bearer ${token}`,
        'Impersonate-Org-UUID': `${org_uuid}`,
        'Headless-Mode': true,
      };
      const params = {
        ...filters,
      };
      const { url } = listKnowledgebaseOverridesConfig();
      const result = await Axios.get(url, { headers, params });
      if (result?.status === 200) {
        dispatch(knowledgebaseOverridesListSlice(result?.data));
      }
    } catch (e) {
      showToastError('Failed to load knowledgebase overrides');
    } finally {
      dispatch(knowledgebaseOverridesLoadingSlice(false));
    }
  };
};

export const getKnowledgebaseOverridesAction = (org_uuid, knowledgebaseId) => {
  return async (dispatch) => {
    dispatch(knowledgebaseOverridesLoadingSlice(true));
    try {
      const token = FronteggContext.getAccessToken();
      const headers = {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        Authorization: `Bearer ${token}`,
        'Impersonate-Org-UUID': `${org_uuid}`,
        'Headless-Mode': true,
      };
      const { url } = getKnowledgebaseOverridesConfig(knowledgebaseId);
      const result = await Axios.get(url, { headers });
      if (result?.status === 200) {
        dispatch(knowledgebaseOverridesItemSlice(result?.data));
      }
    } catch (e) {
      showToastError('Failed to load knowledgebase overrides item');
    } finally {
      dispatch(knowledgebaseOverridesLoadingSlice(false));
    }
  };
};

export const updateKnowledgebaseOverridesAction = (
  org_uuid,
  knowledgebaseId,
  payload,
  successCallback
) => {
  return async (dispatch) => {
    dispatch(knowledgebaseOverridesLoadingSlice(true));
    try {
      const token = FronteggContext.getAccessToken();
      const headers = {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        Authorization: `Bearer ${token}`,
        'Impersonate-Org-UUID': `${org_uuid}`,
        'Headless-Mode': true,
      };
      const { url } = updateKnowledgebaseOverridesConfig(knowledgebaseId);
      const result = await Axios.put(url, payload, { headers });
      if (result?.status === 200) {
        dispatch(knowledgebaseOverridesItemSlice(result?.data));
        showToastSuccess('Knowledgebase overrides updated successfully');
        successCallback?.();
      }
    } catch (e) {
      showToastError('Failed to update knowledgebase overrides');
    } finally {
      dispatch(knowledgebaseOverridesLoadingSlice(false));
    }
  };
};

export const createKnowledgebaseOverridesAction = (
  org_uuid,
  payload,
  successCallback
) => {
  return async (dispatch) => {
    dispatch(knowledgebaseOverridesLoadingSlice(true));
    try {
      const token = FronteggContext.getAccessToken();
      const headers = {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        Authorization: `Bearer ${token}`,
        'Impersonate-Org-UUID': `${org_uuid}`,
        'Headless-Mode': true,
      };
      const { url } = createKnowledgebaseOverridesConfig();
      const result = await Axios.post(url, payload, { headers });
      if (result?.status === 201) {
        showToastSuccess('Knowledgebase overrides created successfully');
        successCallback?.();
      }
    } catch (e) {
      showToastError('Failed to create knowledgebase overrides');
    } finally {
      dispatch(knowledgebaseOverridesLoadingSlice(false));
    }
  };
};

export const deleteKnowledgebaseOverridesAction = (
  org_uuid,
  knowledgebaseId,
  successCallback
) => {
  return async (dispatch) => {
    dispatch(knowledgebaseOverridesLoadingSlice(true));
    try {
      const token = FronteggContext.getAccessToken();
      const headers = {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        Authorization: `Bearer ${token}`,
        'Impersonate-Org-UUID': `${org_uuid}`,
        'Headless-Mode': true,
      };
      const { url } = getKnowledgebaseOverridesConfig(knowledgebaseId);
      const result = await Axios.delete(url, { headers });
      if (result?.status === 200) {
        showToastSuccess('Knowledgebase overrides deleted successfully');
        successCallback?.();
      }
    } catch (e) {
      showToastError('Failed to delete knowledgebase overrides');
    } finally {
      dispatch(knowledgebaseOverridesLoadingSlice(false));
    }
  };
};
